/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import product from "../../../../models/product";
import "../../../../css/Lv2SelectOptionBtn.css";
import { order } from "../../../../models";

let $ = window.$;

class Lv2SelectOptionBtn extends React.Component {
  state = {
    myCbu: {},
    isSoldOut: false,
    productCbu: "",
    myStockQuantity: "",
    isOutOfStock: false
  };
  componentDidUpdate() {
    const {
      stockQuantity,
      earmarkQuantity,
      cartItems,
      product,
      cbu
    } = this.props;
    function outOfStock(stockQuantity, earmarkQuantity, purchase) {
      return stockQuantity - earmarkQuantity - purchase <= 0;
    }
    function howManyMineInMiniCart(cartItems, myCbu) {
      let count = 0;

      cartItems &&
        cartItems.forEach(function(item) {
          if (item.cbu === myCbu) {
            count++;
          }
        });
      return count;
    }

    if (product.cbu === cbu) {
      //算出我在miniCart 有幾筆?
      const purchase = howManyMineInMiniCart(cartItems, cbu);

      //是否我outOfStock
      let isOutOfStock = outOfStock(stockQuantity, earmarkQuantity, purchase);

      this.setState((prevState, props) => {
        if (prevState.isOutOfStock !== isOutOfStock) {
          return {
            ...this.state,
            isOutOfStock: isOutOfStock
          };
        }
      });
    }
  }

  getClass(defaultValue, itemCode) {
    //如果賣完，選項也要變灰色
    if (this.state.isOutOfStock) {
      return "notAvailable blockBtn border-grey smaller";
    }
    if (itemCode === defaultValue) {
      return "select blockBtn border-grey smaller";
    }
    return "blockBtn border-grey smaller";
  }
  handleClick = async e => {
    const {
      code,
      selectLv2Option,
      changeLv2SelectOptionDefault,
      clickLv2OptionToChangeLv3,
      resetQuantity,
      stockQuantity
    } = this.props;

    await resetQuantity();
    await selectLv2Option(code);
    await changeLv2SelectOptionDefault(code); //更新Lv2 default 顯示
    await clickLv2OptionToChangeLv3(); //設定Lv2有被click
    await this.setState({
      ...this.state,
      myStockQuantity: stockQuantity
    });

    if (this.props.unit.quantity > 0) {
      $(".outOfStockForm_wrap")
        .finish()
        .fadeOut();
    }
  };
  render() {
    const { code, lv2Default, name } = this.props;

    return (
      <a
        className={this.getClass(lv2Default, code)}
        onClick={e => this.handleClick(e)}
      >
        <span>{name}</span>
      </a>
    );
  }
}

const mapStateToProps = state => {
  return {
    lv2Default: state.product.lv2Default,
    unit: state.product.productBookingUnit,
    stockQuantity: state.product.productBookingUnit.quantity,
    earmarkQuantity: state.product.productBookingUnit.earmarkQuantity,
    cartItems: state.cart.cartItems,
    product: state.product.productBookingUnit
  };
};

const mapDispatchToProps = () => {
  return {
    resetQuantity: () => order.actions.resetQuantity(),
    selectLv2Option: code => product.actions.selectLv2Option(code),
    changeLv2SelectOptionDefault: data =>
      product.actions.changeLv2SelectOptionDefault(data),
    clickLv2OptionToChangeLv3: () => {
      product.actions.clickLv2OptionToChangeLv3();
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Lv2SelectOptionBtn);
